module.exports = __webpack_public_path__ + "img/left_right_layout_3_old.43d9c2e8.svg";